import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import { XMLHttpRequestHandler, XMLHttpRequestHandler_requestType  } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {contentPresetEdit_template} from "../components/templates/contentPresetEdit_template";
import {vn_app_zone_notification} from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";

declare var ko: any;
declare var page: any;
declare var CKEDITOR: any;
CKEDITOR.timestamp = '1.2.0';

let contentEditor;

export class content_preset_edit extends vnModule_knockoutJS{
    protected contentPresetEdit : contentPresetEdit_template
    protected XHRHdl: XMLHttpRequestHandler;
    protected _isLeavePageWarningNeeded: boolean = true;

    buildContent(): Array<Element> {
        this.contentPresetEdit = new contentPresetEdit_template('content_preset_edit_template', this.viewModel, this)
        return [this.contentPresetEdit.build()]
    }

    protected getModuleName(): string {
        return "content_preset_edit";
    }

    public fillPage() {
        this.getContentPresetDataForEdit()
    }

    private getContentPresetDataForEdit() {
        this.loadingIn(this.contentPresetEdit.builtTemplate);

        let url : string = '/api/brand/' + this.getVnAppZone().app.params.idBrand + '/contentpreset/get/edit/' + this.getVnAppZone().app.params.id + '/';
        let request_parameters : Array<Array<string>> = [];
        this.XHRHdl = new XMLHttpRequestHandler(url, request_parameters, this);
        this.XHRHdl.onReadyStateFunction = this.onGetContentPresetDataForEdit;
        this.XHRHdl.execute();
    }

    private onGetContentPresetDataForEdit(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {

                let responseParsed = JSON.parse(req.request.response);
                let contentpreset = responseParsed.data
                obj.setContentPresetData(contentpreset);

            });

            obj.loadingOut(obj.contentPresetEdit.builtTemplate);
        }
    }

    protected setContentPresetData(contentPreset) {

        this.initializeCkEditor()
        this.contentPresetEdit.setId(contentPreset.id)
        this.contentPresetEdit.setType(contentPreset.type)
        this.contentPresetEdit.setIdItem(contentPreset.idItem)
        this.contentPresetEdit.setContent(contentPreset.content)
        this.contentPresetEdit.setIsActive(contentPreset.isActive)

    }

    protected initializeCkEditor() {
        if (!CKEDITOR.stylesSet.registered.my_styles) {
            CKEDITOR.stylesSet.add('my_styles', [
                // Block-level styles.
                /*{ name: 'Related: One link', element: 'h2', styles: { color: 'Blue' } },
                { name: 'Next - One link',  element: 'h3', styles: { color: 'Red' } },*/
                {name: 'Heading 1', element: 'h1'},
                {name: 'Heading 2', element: 'h2'},
                {name: 'Heading 3', element: 'h3'},
                {name: 'Preformatted', element: 'pre'},
                // Inline styles.
                {name: 'Related: One link', element: 'span', attributes: {'class': 'related-single'}},
                {name: 'Next - One link', element: 'span', attributes: {'class': 'next-single'}},
                {name: 'Affiliate - One link', element: 'span', attributes: {'class': 'affiliate-single'}},
                {name: 'Spoiler Alert', element: 'span', attributes: {'class': 'article-alert'}},
            ]);
        }


        CKEDITOR.on('dialogDefinition', function (ev) {
            var dialogName = ev.data.name;
            var dialogDefinition = ev.data.definition;

            //remove features from table dialog
            if (dialogName == 'table') {

                // Get the advanced tab reference
                var infoTab2 = dialogDefinition.getContents('advanced');

                //Set the default
                // Remove the 'Advanced' tab completely
                dialogDefinition.removeContents('advanced');

                // Get the properties tab reference
                var infoTab = dialogDefinition.getContents('info');

                // Remove unnecessary bits from this tab
                /// infoTab.remove('txtBorder');
                infoTab.remove('cmbAlign');
                infoTab.remove('txtWidth');
                infoTab.remove('txtHeight');
                // infoTab.remove('txtCellSpace');
                //infoTab.remove('txtCellPad');
                infoTab.remove('txtCaption');
                infoTab.remove('txtSummary');
            }

            if (dialogName == 'link') {

                /* Getting the contents of the Target tab */

                var targetTab = dialogDefinition.getContents('target');
                var informationTab = dialogDefinition.getContents('info');
                var advancedTab = dialogDefinition.getContents('advanced');

                //remove the browse server button
                informationTab.remove('browse')

                //moving the target dropdown to the main tab
                var targetField = targetTab.get('linkTargetType');

                targetTab.remove('linkTargetType');
                informationTab.add(targetField);

            }
        });

        let _myThis = this;
        CKEDITOR.on('instanceReady', function (evt) {
            var editor = evt.editor;

            editor.on('afterSetData', function (e) {
            });

            editor.on('focus', function (e) {

            });

        });


        this.initCkEditor('contenttext');
        contentEditor = CKEDITOR.instances.contenttext;
        this.addImagePlaceholderCommand(contentEditor);
        this.addTagPlaceholderCommand(contentEditor);


    }

    protected initCkEditor(idElement) {

        CKEDITOR.replace(idElement, {
            height: '500px',
            toolbar: 'MA',
            fillEmptyBlocks: false,
            extraAllowedContent: 'img(*){*}[*];div(*){*}[*];pre(*){*}[*];code(*){*}[*];a[rel];a[target];a(*)',
            disallowedContent: 'p',
            removePlugins: 'elementspath,contextmenu,liststyle,tabletools,tableselection,image,forms',
            stylesSet: 'my_styles',
            format_tags: "p;h1;h2;h3",
            format_p: {
                element: 'p'
            }
        });

        //'JustifyLeft','JustifyCenter','JustifyRight','JustifyBlock'
        //'Outdent','Indent'

        CKEDITOR.config.toolbar_MA = [['Source', '-', 'Cut', 'Copy', 'Paste', '-', 'Undo', 'Redo', 'RemoveFormat', '-', 'Link', 'Unlink', '-', 'Table', 'HorizontalRule', 'SpecialChar', 'ImgBtn', 'Styles'], ['Bold', 'Italic', 'Strike', 'NumberedList', 'BulletedList', '-', 'Blockquote', 'Maximize'], ['ImagePlaceholder', 'TagPlaceholder']];

        CKEDITOR.config.enterMode = CKEDITOR.ENTER_BR;

        CKEDITOR.config.contentsCss = [CKEDITOR.getUrl('contents.css'), '/css/cke_style.css?v=2.6'];

        //CKEDITOR.config.disallowedContent = 'p';

        CKEDITOR.config.skin = "emakiCustomComprehensive";
        //CKEDITOR.config.skin ="kama";
        //CKEDITOR.config.skin ="moono";
        //CKEDITOR.config.skin ="moono-lisa";

        CKEDITOR.config.extraPlugins = "wordcount,notification";
        //CKEDITOR.config.extraPlugins ="justify";
        //CKEDITOR.config.extraPlugins ="colorbutton";

        CKEDITOR.config.forcePasteAsPlainText = true;
        contentEditor = CKEDITOR.instances.contenttext;

        CKEDITOR.config.wordcount = {
            // Whether or not you want to show the Paragraphs Count
            showParagraphs: false,

            // Whether or not you want to show the Word Count
            showWordCount: true,

            // Whether or not you want to show the Char Count
            showCharCount: true
        }
        CKEDITOR.config.allowedContent = true;


    }

    protected addImagePlaceholderCommand(editor) {
        function showImagePlaceholderTool(obj) {
            return {
                exec: function (editor) {
                    obj.showImagePlaceholderTool();
                }
            };
        }

        editor.addCommand("ImagePlaceholderCommand", showImagePlaceholderTool(this));
        editor.ui.addButton('ImagePlaceholder', { // add new button and bind our command
            label: "Insert Image Placeholder",
            command: 'ImagePlaceholderCommand',
            toolbar: 'insert',
        });
    }

    protected addTagPlaceholderCommand(editor) {
        function showTagPlaceholderTool(obj) {
            return {
                exec: function (editor) {
                    obj.showTagPlaceholderTool();
                }
            };
        }

        editor.addCommand("TagPlaceholderCommand", showTagPlaceholderTool(this));
        editor.ui.addButton('TagPlaceholder', { // add new button and bind our command
            label: "Insert Tag Placeholder",
            command: 'TagPlaceholderCommand',
            toolbar: 'insert',
        });
    }

    protected showImagePlaceholderTool() {
        this.insertPlaceholder('/assets/images/placeholder/placeholder-img.png');
    }

    protected showTagPlaceholderTool() {
        this.insertPlaceholder('/assets/images/placeholder/placeholder-tag.png');
    }

    protected insertPlaceholder(src) {
        let img = '<img src="' + src + '" />';
        contentEditor.insertHtml(img);
    }

    public cancelForm() {
        this.onClickCancelEdit();
    }

    public onClickCancelEdit(){
        let brandId = this.getVnAppZone().app.params.idBrand
        page.redirect("/brand/" + brandId + "/config/content-presets/" )
    }


    protected save(){
        this.loadingIn(this.contentPresetEdit.builtTemplate);

        let idBrand = this.getVnAppZone().getApp().params.idBrand;

        let formReq_url: string = '/api/brand/' + idBrand + "/contentpreset/save/";
        let formReq_params: Array<Array<string>> = [];

        this.viewModel.content_preset_edit_template.content(contentEditor.getData())

        let subViewModel = JSON.parse(ko.toJSON(this.viewModel));


        formReq_params.push(["data", ko.toJSON(subViewModel)]);

        let XHRHdl: XMLHttpRequestHandler = new XMLHttpRequestHandler(formReq_url, formReq_params, this);
        XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        XHRHdl.onReadyStateFunction = (function (req, obj) {

            return function () {

                obj.manageResponse(req, obj, function () {

                    page.redirect('/brand/' + idBrand + "/config/content-presets/");

                    if (req.request.status === 200) {
                        obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, "Content preset saved !");
                        //obj.getVnAppZone().showNotificationToModule();
                    }

                });
                obj.loadingOut(obj.contentPresetEdit.builtTemplate);



            }
        });
        XHRHdl.execute();
    }


}


// WEBPACK FOOTER //
// ./js/modules/content_preset_edit.ts